import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getClusterEdgeLocationsQueryKey } from 'hooks/queries/omni/useGetClusterEdgeLocationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type UseDeleteEdgeLocationMutationProps = {
  clusterId: string;
  onSuccess?: () => void;
};

export const useDeleteEdgeLocationMutation = ({
  clusterId,
  onSuccess,
}: UseDeleteEdgeLocationMutationProps) => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: (edgeLocationId: string) => {
      return apiClient.omni.deleteEdgeLocation({
        organizationId: currentOrganization!.id,
        clusterId,
        id: edgeLocationId,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getClusterEdgeLocationsQueryKey({ clusterId }),
      });
      notify.success('Edge location deleted successfully!');
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
